import React from "react";
import styled from "styled-components";
import { SketchPicker, ColorResult } from "react-color";

import { useDialogA11y } from "../../../ScanTo/ModalContentWrapper/shared/useDialogA11y";

const PopoverContainer = styled.div`
    position: absolute;
    z-index: 100;
    top: 50px;
    left: 60px;
`;

const PopoverCover = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

type ColorPickerPopoverProps = {
    color: string;
    onChange: (hex: string) => void;
    onClose: () => void;
    "data-testid"?: string;
};

// Shared a11y-compliant popover for the three Servio color pickers
// (Commandes / Notifications / Tables filter cards). useDialogA11y wires up
// Escape, focus trap, initial focus and focus restoration; the cover div
// closes the popover on outside-click.
export function ColorPickerPopover({
    color,
    onChange,
    onClose,
    "data-testid": dataTestId,
}: ColorPickerPopoverProps): JSX.Element {
    const { dialogRef } = useDialogA11y({ onCancel: onClose });

    return (
        <PopoverContainer
            ref={dialogRef}
            role="dialog"
            aria-modal="true"
            tabIndex={-1}
            data-testid={dataTestId}
        >
            <PopoverCover onClick={onClose} />
            <SketchPicker
                color={color}
                onChange={(c: ColorResult) => onChange(c.hex)}
            />
        </PopoverContainer>
    );
}
